// Sample LEKA vitals payload (dev-only) used to preview numeric vital cards
// via the "Load Mock Data" button in VitalsCheck. HIGO's own vitals are
// excluded from the merged view by default (DEFAULT_VITALS_EXCLUDED_SOURCES
// in constants), so this stands in for a real LEKA "Vitals" WS event to show
// the full results view (numeric vitals + HIGO visual media) together.
const leekaMeasurementsMock = [
  { measurementType: "HEIGHT", value: "170.8", unit: "cm", textValue: "" },
  { measurementType: "WEIGHT", value: "90.3", unit: "kg", textValue: "" },
  { measurementType: "BMI", value: "31", unit: "kg/m²", textValue: "" },
  { measurementType: "PROTEIN", value: "14.2", unit: "kg", textValue: "" },
  { measurementType: "PROTEIN_RATE", value: "15.8", unit: "%", textValue: "" },
  { measurementType: "BONE_MASS", value: "3.7", unit: "kg", textValue: "" },
  { measurementType: "BONE_SALT", value: "2.5", unit: "mmol/L", textValue: "" },
  { measurementType: "BASAL_METABOLISM", value: "1822", unit: "kcal", textValue: "" },
  { measurementType: "BODY_MUSCLE_CONTENT", value: "61.1", unit: "kg", textValue: "" },
  { measurementType: "BODY_MUSCLE_RATE", value: "67.7", unit: "%", textValue: "" },
  { measurementType: "VISCERAL_FAT_GRADE", value: "16", unit: "grade", textValue: "" },
  { measurementType: "FAT_FREE_MASS", value: "63.6", unit: "kg", textValue: "" },
  { measurementType: "BODY_WATER_CONTENT", value: "46.9", unit: "kg", textValue: "" },
  { measurementType: "BODY_WATER_RATE", value: "51.9", unit: "%", textValue: "" },
  { measurementType: "INTRACELLULAR_FLUID_VOLUME", value: "31.2", unit: "L", textValue: "" },
  { measurementType: "INTRACELLULAR_FLUID_RATE", value: "34.6", unit: "%", textValue: "" },
  { measurementType: "EXTRACELLULAR_FLUID_VOLUME", value: "15.6", unit: "L", textValue: "" },
  { measurementType: "EXTRACELLULAR_FLUID_RATE", value: "17.3", unit: "%", textValue: "" },
  { measurementType: "BODY_FAT_CONTENT", value: "26.7", unit: "kg", textValue: "" },
  { measurementType: "BODY_FAT_RATE", value: "29.6", unit: "%", textValue: "" },
  { measurementType: "SYSTOLIC", value: "145", unit: "mmHg", textValue: "" },
  { measurementType: "DIASTOLIC", value: "95", unit: "mmHg", textValue: "" },
  { measurementType: "HEART_RATE", value: "72", unit: "bpm", textValue: "" },
  { measurementType: "SPO2", value: "98", unit: "%", textValue: "" },
  { measurementType: "TEMPERATURE", value: "38.5", unit: "°C", textValue: "" },
  { measurementType: "GLUCOSE", value: "5.6", unit: "mmol/L", textValue: "" },
  { measurementType: "URIC_ACID", value: "0.3", unit: "mmol/L", textValue: "" },
  { measurementType: "FEV1", value: "3.2", unit: "L", textValue: "" },
  { measurementType: "FVC", value: "4.1", unit: "L", textValue: "" },
  { measurementType: "PEF", value: "7.8", unit: "L/min", textValue: "" },
  { measurementType: "LUNG_FUNCTION_INDEX", value: "82", unit: "%", textValue: "" },
  { measurementType: "WAIST_CIRCUMFERENCE", value: "78", unit: "cm", textValue: "" },
  { measurementType: "HIP_CIRCUMFERENCE", value: "96", unit: "cm", textValue: "" },
  { measurementType: "WAIST_HIP_RATIO", value: "0.81", unit: "", textValue: "" },
  { measurementType: "TOTAL_CHOLESTEROL", value: "4.8", unit: "mmol/L", textValue: "" },
  { measurementType: "HDL_CHOLESTEROL", value: "1.4", unit: "mmol/L", textValue: "" },
  { measurementType: "LDL_CHOLESTEROL", value: "3.6", unit: "mmol/L", textValue: "" },
  { measurementType: "TRIGLYCERIDES", value: "1.2", unit: "mmol/L", textValue: "" },
  { measurementType: "CHOLESTEROL_HDL_RATIO", value: "3.4", unit: "", textValue: "" },
  { measurementType: "VISUAL_ACUITY_LEFT", value: "1", unit: "", textValue: "" },
  { measurementType: "VISUAL_ACUITY_RIGHT", value: "0.9", unit: "", textValue: "" },
  { measurementType: "COLOR_BLINDNESS", value: "", unit: "", textValue: "Normal" },
  { measurementType: "ECG", value: "63", unit: "bpm", textValue: "Sinus rhythm, no abnormality detected" },
];

export default leekaMeasurementsMock;
